import { Box, Button, Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FeatureSubscriptionPaymentCycle } from 'queries';

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedOption: any;
  // eslint-disable-next-line @typescript-eslint/ban-types
  setSelectedOption: Function;
  leftLabel: string;
  rightLabel: string;
};

const useStyles = makeStyles(() => ({
  switchContainer: {
    height: '35px',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #1A2139',
    borderRadius: '20px',
    overflow: 'hidden',
    background: '#1C2541',
    width: '350px',
  },
  switchButton: {
    flex: '1 1 auto',
    outline: 'none',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '1rem',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
    width: '50%',
    '&:hover': {
      background: 'transparent',
    },
  },
  chip: {
    position: 'absolute',
    top: '50%',
    width: '100%',
    height: '80%',
    transform: 'translateX(-50%) translateY(-50%)',
    transition: 'transform 0.3s',
    zIndex: -1,
    background: '#fff',
  },
  deselectedButton: {
    color: '#fff',
  },
  selectedButton: {
    color: '#fff',
  },
}));

const LabeledSwitch = ({ selectedOption, setSelectedOption, leftLabel, rightLabel }: Props) => {
  const classes = useStyles();

  const handleOptionChange = (option: FeatureSubscriptionPaymentCycle) => {
    setSelectedOption(option);
  };

  return (
    <Box className={classes.switchContainer}>
      <Button
        className={`${classes.switchButton} ${
          selectedOption === FeatureSubscriptionPaymentCycle.Yearly
            ? classes.selectedButton
            : classes.deselectedButton
        }`}
        onClick={() => handleOptionChange(FeatureSubscriptionPaymentCycle.Yearly)}
      >
        <Chip
          style={{
            background:
              selectedOption === FeatureSubscriptionPaymentCycle.Yearly ? '#fff' : 'transparent',
            height: '25px',
            width: '100%',
            color: selectedOption === FeatureSubscriptionPaymentCycle.Yearly ? '#1C2541' : '#fff',
          }}
          label={leftLabel}
        />
        {selectedOption === FeatureSubscriptionPaymentCycle.Yearly && (
          <Chip className={classes.chip} />
        )}
      </Button>
      <Button
        className={`${classes.switchButton} ${
          selectedOption === FeatureSubscriptionPaymentCycle.Monthly
            ? classes.selectedButton
            : classes.deselectedButton
        }`}
        onClick={() => handleOptionChange(FeatureSubscriptionPaymentCycle.Monthly)}
      >
        <Chip
          style={{
            background:
              selectedOption === FeatureSubscriptionPaymentCycle.Monthly ? '#fff' : 'transparent',
            height: '25px',
            width: '100%',
            color: selectedOption === FeatureSubscriptionPaymentCycle.Monthly ? '#1C2541' : '#fff',
          }}
          label={rightLabel}
        />
        {selectedOption === FeatureSubscriptionPaymentCycle.Monthly && (
          <Chip className={classes.chip} />
        )}
      </Button>
    </Box>
  );
};

export default LabeledSwitch;
